// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CheckoutDemo: MarkdocTagRegistration = {
  tag: 'checkout-demo',
  component: 'CheckoutDemo',
};
